import React from "react";

export default function GreyCard({ children }) {
  return (
    <section className="bg-light-gray6 drop-shadow-xl p-6 mb-8 max-w-full">
      {children}
    </section>
  );
}
